// extracted by mini-css-extract-plugin
export default {"Dropdown-menu":"StoppedSms_Dropdown-menu__6ceNb","container":"StoppedSms_container__rdv58","emoji":"StoppedSms_emoji__FPKGa","text":"StoppedSms_text__mpmes"};